import forge from "node-forge";
import axios from "axios";
import Swals from "@/assets/js/Swals";


async function Heisenberg(option, url , uid) {

    option.ChangeTheGame = 'DoNotLetTheGameChangeYou!'
    option.ch = 'user'
    if (uid){ let id = PinkMan(localStorage.getItem('uid') , 'de'); option.uid = id}
    const DOM = 'https://market-app.ir/';


    // // رمزگذاری داده
    // const world = '4444555566667777';
    // const cipher = forge.cipher.createCipher('AES-CBC', world);
    // cipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
    // cipher.update(forge.util.createBuffer(unescape(encodeURIComponent(JSON.stringify(option)))));
    // cipher.finish();
    // let data = forge.util.encode64(cipher.output.data);

    return await axios.post(DOM + url, option);
}

 function PinkMan(data, type) {

    const world = '4444555566667777';

    if (type === 'en') {

        const cipher = forge.cipher.createCipher('AES-CBC', world);
        cipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
        cipher.update(forge.util.createBuffer(unescape(encodeURIComponent(JSON.stringify(data)))));
        cipher.finish();
        return forge.util.encode64(cipher.output.data)
    }

    if (type === 'de') {

        const decipher = forge.cipher.createDecipher('AES-CBC', world);
        decipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
        decipher.update(forge.util.createBuffer(forge.util.decode64(data)));
        decipher.finish();
        return JSON.parse(decipher.output.toString())
    }


}

async function GoodMan(file) {

    if (!file.type.includes('image')){
        Swals.Warning('لطفا از فرمت های عکس برای آپلود استفاده کنید!')
        return false
    }

    if (file.size > 5000000){
        Swals.Warning('حداکثر حجم مجاز برای آپلود عکس 5 مگابایت است!')
        return false
    }


    let option = {
        file: file
    }

    const DOM = 'https://market-app.ir/upload';
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }

    return await axios.post(DOM, option, config);
}

export default {Heisenberg , PinkMan , GoodMan};